import { identifyCustomer } from "./gtm/data-layer";
import { initBanner } from "./banner";
import type { SwiftWidgetsConfig } from "./types";

const DEFAULT_API_BASE_URL = "http://be.concordswift.com";

let config: SwiftWidgetsConfig = {
  apiBaseUrl: DEFAULT_API_BASE_URL,
  projectId: "",
};

export function init(options: SwiftWidgetsConfig): void {
  if (!options?.projectId) {
    throw new Error("SwiftWidgets.init() requires a projectId");
  }

  config = {
    apiBaseUrl: options.apiBaseUrl ?? DEFAULT_API_BASE_URL,
    projectId: options.projectId,
    banner: options.banner,
  };
  identifyCustomer();

  if (config.banner?.enabled && config.banner?.autoShow !== false) {
    initBanner();
  }
}

export function getConfig(): SwiftWidgetsConfig {
  return config;
}
